import { Component } from '@angular/core';

@Component({
  templateUrl: './business-unification.page.html',
})
/**
 * Business Unification Page
 */
export class BusinessUnificationPage {}
